import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import { ChargebackReason, PaymentStatus as PaymentStatusType } from '../../Shared/types';

interface PaymentStatusLabelProps {
  payment: {
    payment_status: PaymentStatusType;
    chargeback_reason: ChargebackReason | null;
  },
}

export default function PaymentStatusLabel({ payment }: PaymentStatusLabelProps) {
  const { t } = useTranslation();

  const paymentClassName = {
    [PaymentStatusType.PAID]: 'text-emerald-600',
    [PaymentStatusType.PENDING]: 'text-slate-600',
    [PaymentStatusType.CANCELED]: 'text-red-600',
    [PaymentStatusType.EXPIRED]: 'text-red-600',
    [PaymentStatusType.FAILED]: 'text-red-600',
  };

  return (
    <span className={classNames(
      'font-medium',
      payment.chargeback_reason ? 'text-red-600' : paymentClassName[payment.payment_status],
    )}>
      {t(`shared:payment_status.${payment.chargeback_reason ? 'chargeback' : payment.payment_status}`)}
    </span>
  );
}
